import { render, staticRenderFns } from "./MasterclassCardMobile.vue?vue&type=template&id=28da044c&"
import script from "./MasterclassCardMobile.vue?vue&type=script&lang=js&"
export * from "./MasterclassCardMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports